export enum NotConfirmedUsersActions{
    SET_SELECTED_NOT_CONFIRMED_USERS = "setSelectedNotConfirmedUser",
    SET_NOT_CONFIRMED_USER = "setNotConfirmedUser",
    TOGGLE_NOT_CONFIRMED_USER_PANEL = "toggleNotConfirmedUserPanel",
    RELOAD_NOT_CONFIRMED_USER = "reloadNotConfirmedUser",
    CLEAR= "clearNotConfirmedUsers",
}